import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Col, Row, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//icon
import { AiOutlineEye } from 'react-icons/ai';
//helpers
import { verificateNullValue } from 'helpers';
//components
import CustomInput from 'components/backoffice/customInput';
import Button from 'components/backoffice/buttonCustom';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import WatchModal from 'components/backoffice/modals/WatchModal';
import SpinnerComponent from 'components/backoffice/SpinnerComponent';
import TermsForm from './termsForm';
import PolicyForm from './policyForm';
import CookieForm from './cookieForm';
import ThemeSelector from './ThemeSelector';

const CompanyForm = ({
  isEditing,
  onSubmitForm,
  fileInputRef,
  onDelete,
  openModalDelete,
  setOpenModalDelete,
  loading,
  defaultValues,
  beforeTitle
}) => {
  const [openModalImage, setOpenModalImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const { t } = useTranslation(['backoffice']);
  const {
    formState: { errors },
    getValues,
    setValue,
    control,
    handleSubmit,
  } = useForm();


  const logo = getValues('logo');
  const homeImage = getValues('home_image');

  const processImage = (image) => {
    if (typeof image === 'string') {
      return image;
    } else if (image instanceof Blob || image instanceof File) {
      return URL.createObjectURL(image);
    }
    return '';
  };

  useEffect(() => {
    if (selectedType) {
      if (selectedType === 'logo') {
        setSelectedImage(processImage(logo));
      } else if (selectedType === 'home_image') {
        setSelectedImage(processImage(homeImage));
      }
    }
  }, [selectedType, logo, homeImage]);


  useEffect(() => {
    if (defaultValues) {
      if (defaultValues?.logo) {
        fetch(defaultValues?.logo, { cache: "no-store" })
          .then((response) => response.blob())
          .then((blob) => {
            const name = defaultValues?.logo.split('?')[0].split('/').pop()
            const file = new File([blob], name, { type: `image/${name.split('.')[1]}` });
            setValue('logo', file);
          })
          .catch((error) => {
            console.error('Error al obtener la imagen:', error);
          });
      } else setValue('logo', null);
      if (defaultValues?.home_image) {
        fetch(defaultValues?.home_image, { cache: "no-store" })
          .then((response) => response.blob())
          .then((blob) => {
            const name = defaultValues?.home_image.split('?')[0].split('/').pop();
            const file = new File([blob], name, { type: `image/${name.split('.')[1]}` });
            setValue('home_image', file);
          })
          .catch((error) => {
            console.error('Error al obtener la imagen home_image:', error);
          });
      } else setValue('home_image', null);
      setValue('email', defaultValues?.email || '');
      setValue('web_url', defaultValues?.web_url || '');
      setValue('direccion', verificateNullValue(defaultValues?.direccion) || '');
      setValue('telefono', defaultValues?.telefono !== "" ? parseInt(defaultValues?.telefono?.replace(/\s/g, "")) : '');
      setValue('latitude', verificateNullValue(defaultValues?.latitude) || '');
      setValue('longitude', defaultValues?.longitude || '');
      setValue('business_hours', verificateNullValue(defaultValues?.business_hours) || '');
      setValue('facebook', verificateNullValue(defaultValues.redes_sociales?.facebook) || '');
      setValue('twitter', verificateNullValue(defaultValues.redes_sociales?.twitter) || '');
      setValue('instagram', verificateNullValue(defaultValues.redes_sociales?.instagram) || '');
      setValue('theme', defaultValues?.theme || '');
      setValue('google_play', defaultValues.apps_urls?.google_play || '');
      setValue('app_store', defaultValues.apps_urls?.app_store || '');
      setValue('home_url', defaultValues?.home_url || '');
    }
  }, [defaultValues, setValue]);


  const watchItem = (type) => {
    setSelectedType(type);
    setTimeout(() => {
      setOpenModalImage(true);
    }, 100);
  };


  return (
    <div className="mt-5">
      <Form onSubmit={handleSubmit(onSubmitForm)}>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={12} xl={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="email"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="email"
                  value={value}
                  label={t('correoelectronico')}
                  placeholder={t('correoelectronico')}
                  onChange={(e) => onChange(e)}
                  defaultValue={value}
                />
              )}
            />
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="web_url"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid')
                }
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('webpage')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('webpage')}
                />
              )}
            />
            {errors?.web_url && <small className="text-danger">{errors.web_url.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="business_hours"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('openinghours')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('openinghours')}
                  max={105}
                />
              )}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={12} xl={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="direccion"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('direccion')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('direccion')}
                />
              )}
            />
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="telefono"
              control={control}
              rules={{
                pattern: {
                  value: /^[0-9\b]+$/,
                  message: t('solonumeros'),
                },
                maxLength: {
                  value: 9,
                  message: t('max9characters'),
                },
                minLength: {
                  value: 9,
                  message: t('min9characters'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="tel"
                  label={t('telefono')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('telefono')}
                />
              )}
            />
            {errors?.telefono && <small className="text-danger">{errors.telefono.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0 d-flex gap-3">
            <div className='w-100'>
              <Controller
                name="logo"
                rules={{
                  required: {
                    value: true,
                    message: t('camporequerido'),
                  },
                }}
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <CustomInput
                      type="file"
                      dropFileMsg={t('dropFile')}
                      label={t('logo')}
                      placeholder={t('selectImg')}
                      accept="image/*"
                      value={value}
                      onChange={onChange}
                      ref={fileInputRef}
                    />
                  );
                }}
              />
              {errors?.logo && <small className="text-danger m-1">{errors.logo.message}</small>}
            </div>
            {defaultValues?.logo && (
              <div className="mt-4-3">
                <Button type="button" color="terciary" onClick={() => watchItem('logo')}>
                  <AiOutlineEye color="white" />
                </Button>
              </div>
            )}
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={12} md={12} lg={12} xl={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="facebook"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid'),
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('facebook')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('facebook')}
                />
              )}
            />
            {errors?.facebook && <small className="text-danger">{errors.facebook.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="twitter"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid'),
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('twitter')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('twitter')}
                />
              )}
            />
            {errors?.twitter && <small className="text-danger">{errors.twitter.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="instagram"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid'),
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('instagram')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('instagram')}
                />
              )}
            />
            {errors?.instagram && <small className="text-danger">{errors.instagram.message}</small>}
          </Col>
        </Row>
        <Row className="mt-4">
          {/* Campos latitude y longitude temporalmente deshabilitados
          <Col sm={12} md={12} lg={12} xl={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="latitude"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                },
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="number"
                  label={t('latitude')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('latitude')}
                />
              )}
            />
            {errors?.latitude && <small className="text-danger ">{errors.latitude.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="longitude"
              control={control}
              rules={{
                required: {
                  value: true,
                  message: t('camporequerido'),
                }
              }}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="number"
                  label={t('longitude')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('longitude')}
                />
              )}
            />
            {errors?.longitude && <small className="text-danger ">{errors.longitude.message}</small>}
          </Col>
          */}
          <Col sm={12} md={12} lg={12} xl={4} className="mb-md-2 mb-lg-0">
            <Controller
              name="google_play"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid'),
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('googlePlay')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('googlePlay')}
                />
              )}
            />
            {errors?.google_play && <small className="text-danger">{errors.google_play.message}</small>}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="app_store"
              rules={{
                pattern: {
                  value: /^(ftp|http|https):\/\/[^ "]+$/,
                  message: t('urlvalid'),
                },
              }}
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('appStore')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('appStore')}
                />
              )}
            />
            {errors?.app_store && <small className="text-danger">{errors.app_store.message}</small>}
          </Col>
        </Row>
        <Row className="mt-4">
          <ThemeSelector
            control={control}
            name="theme"
            onThemeChange={(theme) => {
              if (theme && theme.theme) {
                const styleTag = document.getElementById('x-theme-colors');
                if (styleTag) {
                  styleTag.innerHTML = theme.theme;
                }
              }
            }}
            defaultValue={defaultValues?.theme || ''}
          />
        </Row>
        <Row>
          <Col sm={12} md={12} lg={12} xl={12} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <h3 className='text-light text-start mb-4'>{t('promotionalBanner')}</h3>
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0 d-flex gap-3">
            <div className='w-100'>
              <Controller
                name="home_image"
                rules={{
                  required: {
                    value: true,
                    message: t('camporequerido'),
                  },
                }}
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <CustomInput
                      type="file"
                      dropFileMsg={t('dropFile')}
                      label={t('homeImage')}
                      placeholder={t('homeImage')}
                      accept="image/*"
                      value={value}
                      onChange={(e) => onChange(e)}
                      ref={fileInputRef}
                    />
                  );
                }}
              />
              {errors?.home_image && <small className="text-danger m-1">{errors.home_image.message}</small>}
            </div>
            {defaultValues?.home_image && (
              <div className="mt-4-3">
                <Button type="button" color="terciary" onClick={() => watchItem('home_image')}>
                  <AiOutlineEye color="white" />
                </Button>
              </div>
            )}
          </Col>
          <Col sm={12} md={12} lg={12} xl={4} className="mt-4 mt-xl-0 mb-md-2 mb-lg-0">
            <Controller
              name="home_url"
              control={control}
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  label={t('homeUrl')}
                  onChange={(e) => onChange(e)}
                  value={value}
                  placeholder={t('homeUrl')}
                />
              )}
            />
          </Col>
        </Row>
        <div className="mt-4 mb-2 d-flex justify-content-end gap-3">
          <Button
            color="primary"
            onClick={handleSubmit(onSubmitForm)}
            loading={loading}
          >
            {t('save')}
            {loading && <SpinnerComponent loading={loading} />}
          </Button>
          {
            isEditing && (<Button color="secondary" onClick={() => setOpenModalDelete(true)} loading={loading}>
              {t('eliminar')}
            </Button>)
          }
        </div>
      </Form>
      <Row>
        <TermsForm />
      </Row>
      <Row>
        <PolicyForm />
      </Row>
      <Row>
        <CookieForm />
      </Row>
      <DeleteModalCustom
        openModal={openModalDelete}
        setOpenModal={setOpenModalDelete}
        handleDelete={onDelete}
        deleteTitle={t('deleteconfiguration')}
        beforeTitle={beforeTitle}
      />
      <WatchModal
        item={selectedImage}
        title={t('imagen')}
        show={openModalImage}
        setShow={setOpenModalImage}
        beforeTitle={beforeTitle}
        size={selectedType === 'home_image' ? 'lg' : undefined} // Aplica size="lg" solo si es home_image
      />
    </div>
  );
};

CompanyForm.propTypes = {
  onSubmitForm: PropTypes.func.isRequired,
  defaultValues: PropTypes.object,
  isEditing: PropTypes.bool.isRequired,
  valueIcon: PropTypes.any,
  openModalDelete: PropTypes.bool,
  setOpenModalDelete: PropTypes.func,
  onDelete: PropTypes.func,
  id: PropTypes.any,
  beforeTitle: PropTypes.string
};

export default CompanyForm;
